
export const formatCreditCard = (card) => {
  return card.cardHash ? { cardHash: card.cardHash } : { encryptedCard: card.encryptCard }
}

export const validatePaymentData = (userBirthDate, address, creditCard, purchase) => {
  return !!(userBirthDate && address && creditCard && purchase)
}

export const isEntityEnabledForPayment = (entityId, entitiesData) => {
  const entity = entitiesData.find(item => item.id === entityId)
  return entity?.enabledPayment || false
}
